import React from 'react';

// eslint-disable-next-line react/prop-types
const PhonesBackground = ({ name, negative }) => (
  <div className={`c-phones-background ${negative && 'c-phones-background-negative'}`}>
    <img
      width="100%"
      className="u-hide-on-mobile"
      src={`https://squire-emails.s3-us-west-1.amazonaws.com/images/${name}-desktop.png`}
      alt=""
    />
    <img
      width="100%"
      className="u-hide-on-desktop u-mt-10"
      src={`https://squire-emails.s3-us-west-1.amazonaws.com/images/${name}-mobile.png`}
      alt=""
    />
  </div>
);

export default PhonesBackground;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/PhonesBackground.jsx